import { useEffect, useRef, useState } from "react";
import { Search, Plus, ChevronDown, Package, Receipt, FileSignature, LifeBuoy } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@finora/ui";
import { useAuthStore } from "../store/auth-store";

function CompanyMenu() {
  const companyName = useAuthStore((s) => s.companyName) ?? "Vaša firma";
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 rounded-md px-2 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        {companyName}
        <ChevronDown className="h-3.5 w-3.5 text-slate-400" aria-hidden />
      </button>
      {open && (
        <div className="absolute left-0 top-full z-20 mt-1 w-48 rounded-lg border border-border bg-white py-1 shadow-lg">
          <button
            onClick={() => {
              setOpen(false);
              navigate("/moj-paket");
            }}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-app-bg"
          >
            <Package className="h-4 w-4 text-slate-400" aria-hidden />
            Moj paket
          </button>
          <button
            onClick={() => {
              setOpen(false);
              navigate("/moji-racuni");
            }}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-app-bg"
          >
            <Receipt className="h-4 w-4 text-slate-400" aria-hidden />
            Moji računi
          </button>
          <button
            onClick={() => {
              setOpen(false);
              navigate("/moj-ugovor");
            }}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-app-bg"
          >
            <FileSignature className="h-4 w-4 text-slate-400" aria-hidden />
            Moj ugovor
          </button>
          <button
            onClick={() => {
              setOpen(false);
              window.location.href = "mailto:podrska@finora.rs";
            }}
            className="flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-slate-700 hover:bg-app-bg"
          >
            <LifeBuoy className="h-4 w-4 text-slate-400" aria-hidden />
            Podrška
          </button>
        </div>
      )}
    </div>
  );
}

export function TopBar() {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  return (
    <header className="flex h-14 flex-shrink-0 items-center gap-4 border-b border-border bg-surface px-5">
      <CompanyMenu />
      <div className="h-5 w-px bg-border" />
      <button className="flex items-center gap-1.5 rounded-md px-2 py-1.5 text-sm text-slate-500 hover:bg-slate-50">
        Prodavnica Centar
        <ChevronDown className="h-3.5 w-3.5 text-slate-400" aria-hidden />
      </button>

      <div className="ml-4 flex-1 max-w-md">
        <label className="relative block">
          <span className="sr-only">Pretraga</span>
          <Search
            className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
            aria-hidden
          />
          <input
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Pretraži dokumente, kupce, artikle..."
            className="w-full rounded-lg border border-border bg-app-bg py-2 pl-9 pr-3 text-sm placeholder:text-slate-400 focus:border-brand focus:bg-white focus:outline-none"
          />
        </label>
      </div>

      <Button size="sm" onClick={() => navigate("/prodaja/nova-ponuda")}>
        <Plus className="h-4 w-4" aria-hidden />
        Novi dokument
      </Button>

      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-light text-sm font-medium text-brand">
        MM
      </div>
    </header>
  );
}
